var map = {
	"./en/createNetworkToken": 47740,
	"./es/createNetworkToken": 66075,
	"./fr/createNetworkToken": 60768,
	"./it/createNetworkToken": 83145,
	"./pt-BR/createNetworkToken": 20711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92638;